module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst {\nnrOfCostCenters,\nnetPrice,\nvatPrice,\nprice,\nsentAt,\nlastProcessedAt,\n} = (((resourceData || {}).data || {}).attributes || {})\n%><div><%\n%><ul><%\n%><li><div class=\"head\"><%= storage.__('invoiceSummary.head.nrOfCostCenters') %></div><div class=\"body\"><%= nrOfCostCenters || 0 %></div></li><%\n%><li><div class=\"head\"><%= storage.__('invoiceSummary.head.netPrice') %></div><div class=\"body\"><%= utils.number.format(netPrice || 0, { min: 0, prefix: '€ ', decimals: 2 }, 'float').formatted %></div></li><%\n%><li><div class=\"head\"><%= storage.__('invoiceSummary.head.vatPrice') %></div><div class=\"body\"><%= utils.number.format(vatPrice || 0, { min: 0, prefix: '€ ', decimals: 2 }, 'float').formatted %></div></li><%\n%><li><div class=\"head\"><%= storage.__('invoiceSummary.head.price') %></div><div class=\"body\"><%= utils.number.format(price || 0, { min: 0, prefix: '€ ', decimals: 2 }, 'float').formatted %></div></li><%\n%><li class=\"date\"><div class=\"head\"><%= storage.__('invoiceSummary.head.sentAt') %></div><div class=\"body\"><%= sentAt ? storage.__('invoiceSummary.body.sentAt', { date: utils.moment(sentAt).format('DD.MM.YYYY'), time: utils.moment(sentAt).format('HH:mm:ss') }) : '-' %></div></li><%\n%><li class=\"date\"><div class=\"head\"><%= storage.__('invoiceSummary.head.lastProcessedAt') %></div><div class=\"body\"><%= lastProcessedAt ? storage.__('invoiceSummary.body.lastProcessedAt', { date: utils.moment(lastProcessedAt).format('DD.MM.YYYY'), time: utils.moment(lastProcessedAt).format('HH:mm:ss') }) : '-' %></div></li><%\n%></ul><%\n%></div>"
  , __filename = "components/templates/office/documents/invoices/summary.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const {
nrOfCostCenters,
netPrice,
vatPrice,
price,
sentAt,
lastProcessedAt,
} = (((resourceData || {}).data || {}).attributes || {})

    ; __line = 10
    ; __append("<div>")
    ; 

    ; __line = 11
    ; __append("<ul>")
    ; 

    ; __line = 12
    ; __append("<li><div class=\"head\">")
    ; __append(escapeFn( storage.__('invoiceSummary.head.nrOfCostCenters') ))
    ; __append("</div><div class=\"body\">")
    ; __append(escapeFn( nrOfCostCenters || 0 ))
    ; __append("</div></li>")
    ; 

    ; __line = 13
    ; __append("<li><div class=\"head\">")
    ; __append(escapeFn( storage.__('invoiceSummary.head.netPrice') ))
    ; __append("</div><div class=\"body\">")
    ; __append(escapeFn( utils.number.format(netPrice || 0, { min: 0, prefix: '€ ', decimals: 2 }, 'float').formatted ))
    ; __append("</div></li>")
    ; 

    ; __line = 14
    ; __append("<li><div class=\"head\">")
    ; __append(escapeFn( storage.__('invoiceSummary.head.vatPrice') ))
    ; __append("</div><div class=\"body\">")
    ; __append(escapeFn( utils.number.format(vatPrice || 0, { min: 0, prefix: '€ ', decimals: 2 }, 'float').formatted ))
    ; __append("</div></li>")
    ; 

    ; __line = 15
    ; __append("<li><div class=\"head\">")
    ; __append(escapeFn( storage.__('invoiceSummary.head.price') ))
    ; __append("</div><div class=\"body\">")
    ; __append(escapeFn( utils.number.format(price || 0, { min: 0, prefix: '€ ', decimals: 2 }, 'float').formatted ))
    ; __append("</div></li>")
    ; 

    ; __line = 16
    ; __append("<li class=\"date\"><div class=\"head\">")
    ; __append(escapeFn( storage.__('invoiceSummary.head.sentAt') ))
    ; __append("</div><div class=\"body\">")
    ; __append(escapeFn( sentAt ? storage.__('invoiceSummary.body.sentAt', { date: utils.moment(sentAt).format('DD.MM.YYYY'), time: utils.moment(sentAt).format('HH:mm:ss') }) : '-' ))
    ; __append("</div></li>")
    ; 

    ; __line = 17
    ; __append("<li class=\"date\"><div class=\"head\">")
    ; __append(escapeFn( storage.__('invoiceSummary.head.lastProcessedAt') ))
    ; __append("</div><div class=\"body\">")
    ; __append(escapeFn( lastProcessedAt ? storage.__('invoiceSummary.body.lastProcessedAt', { date: utils.moment(lastProcessedAt).format('DD.MM.YYYY'), time: utils.moment(lastProcessedAt).format('HH:mm:ss') }) : '-' ))
    ; __append("</div></li>")
    ; 

    ; __line = 18
    ; __append("</ul>")
    ; 

    ; __line = 19
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/office/documents/invoices/summary.ejs

}